import React from "react";
import { Grid } from "semantic-ui-react";
import { Form } from "@redriver/cinnamon";

const DocumentTypeForm = (props) => (
  <Form {...props}>
    <Grid>
      <Grid.Column width={8}>
        <Form.Input field="name" label="Name" fluid required />
        <Form.Checkbox
          field="allowPhotoUploadsFromApp"
          label="Upload Photos from App?"
        />
      </Grid.Column>
    </Grid>
  </Form>
);

export default DocumentTypeForm;
